import { getInitData } from './tma';
import { createVoiceApi } from './voice-api';

export { VoiceApiError } from './voice-api';

export const voiceApi = createVoiceApi({
  baseUrl: import.meta.env.VITE_API_URL ?? '/api',
  getInitData,
});
